import { autoMount } from '../../../utils/autoMount';
import { CompanyTermsSuccess } from '../../../components/pages/companyTermsSuccess';

autoMount({ CompanyTermsSuccess });
